import Chip from '@mui/material/Chip'

import { P } from '@mxenabled/mxui'

import { CardStatus } from '../../common/constants/FinStrong'

import { getCardStateStyles } from '../util/finstrongUtils'
import { useGlobalCopyStore } from '../../common'

const StatusChip = ({ status }: { status: keyof typeof CardStatus }) => {
  const { finstrong: copy } = useGlobalCopyStore()

  const chipStyles = getCardStateStyles(CardStatus[status])
  const statusCopy = {
    GOOD: copy.key_indicators_good,
    FAIR: copy.key_indicators_fair,
    OFF_TRACK: copy.key_indicators_off_track,
    MISSING: copy.key_indicators_missing,
  }[status]

  return (
    <Chip
      label={
        <P
          fontWeight={700}
          sx={{ color: chipStyles.color, minHeight: 12 }}
          uppercase={true}
          variant="tiny"
        >
          {statusCopy}
        </P>
      }
      size="small"
      sx={{
        bgcolor: chipStyles.backgroundColor,
        height: 16,
      }}
      variant="filled"
    />
  )
}

export default StatusChip
